import { memo, ReactNode, useMemo, useState } from "react";
import classNames from "classnames";
import { NavbarContext } from "./NavbarContext";

import styles from "./style.module.scss";

const NavbarContextProvider = memo<{ children: ReactNode | ReactNode[] }>(({ children }) => {
  const [ isFade, setIsFade ] = useState(false);
  const [ open, setOpen ] = useState<{ id: string, status: boolean } | undefined>(undefined);

  const value = useMemo(() => {
    return ({
      isFade,
      setIsFade,
      open,
      setOpen,
    });
  }, [ setIsFade, isFade, open, setOpen ]);

  return (
    <NavbarContext.Provider value={value}>
      {children}
      <div className={classNames({ [styles.fade]: isFade })} />
    </NavbarContext.Provider>
  );
});

export default NavbarContextProvider;
